import { environment } from '~env/environment';

export const IMGIX_BASE_URL = () => environment.imgixProductBaseUrl();
export const IMGIX_IMAGE_FORMATE = 'auto';
export const IMGIX_IMAGE_QUALITY = 70;
export const IMGIX_PRE_PRODUCTION_BASE_URL = 'https://pp-de-metro-markets.imgix.net';
export const IMGIX_PRODUCTION_BASE_URL = 'https://prod-metro-markets.imgix.net';
